/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectData } from '../model/businessObjectData';
import { ErrorInformation } from '../model/errorInformation';
import { RelationalTableRegistrationCreateRequest } from '../model/relationalTableRegistrationCreateRequest';
import { RelationalTableRegistrationDeleteResponse } from '../model/relationalTableRegistrationDeleteResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class RelationalTableRegistrationService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createRelationalTableRegistration
     * Creates relational table registration
     * @param relationalTableRegistrationCreateRequest relational table registration create request
     * @param appendToExistingBusinessObjectDefinition boolean flag that determines if the format should be appended to an existing business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relationalTableRegistrationCreateRelationalTableRegistration(relationalTableRegistrationCreateRequest: RelationalTableRegistrationCreateRequest, appendToExistingBusinessObjectDefinition?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectData>;
    public relationalTableRegistrationCreateRelationalTableRegistration(relationalTableRegistrationCreateRequest: RelationalTableRegistrationCreateRequest, appendToExistingBusinessObjectDefinition?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectData>>;
    public relationalTableRegistrationCreateRelationalTableRegistration(relationalTableRegistrationCreateRequest: RelationalTableRegistrationCreateRequest, appendToExistingBusinessObjectDefinition?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectData>>;
    public relationalTableRegistrationCreateRelationalTableRegistration(relationalTableRegistrationCreateRequest: RelationalTableRegistrationCreateRequest, appendToExistingBusinessObjectDefinition?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (relationalTableRegistrationCreateRequest === null || relationalTableRegistrationCreateRequest === undefined) {
            throw new Error('Required parameter relationalTableRegistrationCreateRequest was null or undefined when calling relationalTableRegistrationCreateRelationalTableRegistration.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (appendToExistingBusinessObjectDefinition !== undefined && appendToExistingBusinessObjectDefinition !== null) {
            queryParameters = queryParameters.set('appendToExistingBusinessObjectDefinition', <any>appendToExistingBusinessObjectDefinition);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectData>(`${this.configuration.basePath}/relationalTableRegistrations`,
            relationalTableRegistrationCreateRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteRelationalTableRegistration
     * Delete a relational table registration.
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relationalTableRegistrationDeleteRelationalTableRegistration(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, observe?: 'body', reportProgress?: boolean): Observable<RelationalTableRegistrationDeleteResponse>;
    public relationalTableRegistrationDeleteRelationalTableRegistration(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RelationalTableRegistrationDeleteResponse>>;
    public relationalTableRegistrationDeleteRelationalTableRegistration(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RelationalTableRegistrationDeleteResponse>>;
    public relationalTableRegistrationDeleteRelationalTableRegistration(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling relationalTableRegistrationDeleteRelationalTableRegistration.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling relationalTableRegistrationDeleteRelationalTableRegistration.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling relationalTableRegistrationDeleteRelationalTableRegistration.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<RelationalTableRegistrationDeleteResponse>(`${this.configuration.basePath}/relationalTableRegistrations/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
